








































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch, Ref } from 'vue-property-decorator'

import TemplateContext from '../includes/TemplateContext'
import { SearchBarItem } from '../includes/types/Config'

@Component
export default class SearchPanel extends Vue {

  @Prop({ type: String, default: 'Search...' }) placeholder!: string

  @Prop({ required: true }) data!: Array<SearchBarItem> | Promise<Array<SearchBarItem>>

  @Prop({ type: Boolean, default: false }) autoFocus!: boolean

  @Ref() input!: HTMLInputElement

  @Ref() option!: Array<HTMLLIElement>

  @Ref() scrollContainer!: HTMLUListElement

  items: Array<SearchBarItem> = []

  searchQuery = ''

  filteredData: Array<SearchBarItem> = []

  currentSelected = -1

  inputFocused = false

  insideSuggestions = false

  dataLoading = false

  @Watch('searchQuery')
  onSearchQueryChange(value: string): void {
    if (value === '') {
      this.inputInit()
    } else {
      this.filteredData = this.items.filter(i => i.title.toLowerCase().includes(value.toLowerCase()))

      if (!this.filteredData[0]) this.currentSelected = -1
    }
  }

  @Watch('autoFocus', { immediate: true })
  onAutoFocusChange(value: boolean): void {
    if (value) this.focusInput()
  }

  mounted(): void {
    if (this.autoFocus) this.focusInput()
  }

  escPressed(): void {
    this.$emit('closeSearchbar')
  }

  inputInit(): void {
    this.filteredData = this.items
  }

  updateInputFocus(value = true): void {
    if (!value) {
      if (this.insideSuggestions) return
      setTimeout(() => {
        this.inputFocused = false
      }, 100)

      this.escPressed()
    }
  }

  suggestionSelected(item:number | string | Event): void {
    // if (typeof item === 'object' && 'target' in item && this.currentSelected !== -1) {

    const search = this.$store.state.AdminTemplate.applicationConfig.search
    let id: number | string | null = null;

    if (typeof item === 'number' || typeof item === 'string') {
      id = item
    }

    if (typeof item === 'object' && 'target' in item) {
      id = this.filteredData[this.currentSelected]?.id ?? null
    }

    if (search) {
      search.path(new TemplateContext(this.$route), this.$router, id)
    }

    if (this.currentSelected !== -1) {
      this.escPressed()
    }
  }

  increaseIndex(value = false): void {
    if (!value && this.currentSelected > 0) this.currentSelected--
    else if (value && this.currentSelected < this.filteredData.length - 1) this.currentSelected++
    this.fixScrolling()
  }

  focusInput(): void {
    if (this.input) {
      this.input.focus()
    }
  }

  fixScrolling(): void {
    if (this.currentSelected > 0) {
      const liH = (this.option[this.currentSelected] as HTMLLIElement).clientHeight
      const ulH = this.scrollContainer.clientHeight

      if (liH * this.currentSelected > ulH) {
        this.scrollContainer.scrollTop = Math.ceil((this.currentSelected + 1 - ulH / liH + 1) * liH)
      } else {
        this.scrollContainer.scrollTop = 0
      }
    }
  }

  async created() {
    if (this.data) {
      this.dataLoading = true

      if (this.data instanceof Promise) {
        this.items = await this.data
      } else {
        this.items = this.data
      }

      this.dataLoading = false
      this.inputInit()

      this.inputFocused = true
    }
  }
}
